import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({
    endPoint: `dossier/campaignHistorical/${dossierId}`,
    method: 'GET',
    body: null,
    token: token
  })
}
